interface IProp {
  className?: string
  size?: number
}

const HeightWidth = (props: IProp) => {
  const { className = 'fill-none stroke-black', size = 20 } = props
  return (
    <svg
    width={size}
    height={size}
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.75 2.67188L2.5 0.921875M2.5 0.921875L4.25 2.67188M2.5 0.921875V9.08854M0.75 7.33854L2.5 9.08854M2.5 9.08854L4.25 7.33854M6.58333 1.50521H10.6667M6.58333 5.00521H10.6667M6.58333 8.50521H10.6667"
        className={className}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default HeightWidth
